<template>
  <div class="frisbuy-customers-photos-skeleton">
    <div
      v-for="idx in props.itemsCount"
      :key="idx"
      class="frisbuy-customers-photos-skeleton__item"
      :style="itemStyle"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    isMobile?: boolean;
    itemsCount?: number;
  }>(),
  {
    isMobile: false,
    itemsCount: 6,
  }
);

const itemStyle = computed(() => {
  if (props.isMobile) {
    return {
      width: "calc((100% - 24px) / 4)",
      aspectRatio: "1 / 1",
    };
  }

  return {
    width: "80px",
    height: "80px",
  };
});
</script>

<style scoped lang="scss">
.frisbuy-customers-photos-skeleton {
  display: flex;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.frisbuy-customers-photos-skeleton__item {
  flex: 0 0 auto;
  border-radius: 12px;
  background: linear-gradient(90deg, #f1f3f5 25%, #e7ebee 37%, #f1f3f5 63%);
  background-size: 400% 100%;
  animation: frisbuy-skeleton-loading 1.4s ease infinite;
}

@keyframes frisbuy-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
